"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgShiftDates(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 0 18 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16 16l5 3-5 3v-2H8v-2h8v-2zM15 4a1 1 0 011 1h4v11.633l-2-1.2V10H6v10H4V5h4a1 1 0 012 0h4a1 1 0 011-1zm-6 7v2H7v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2z" })));
}
exports.default = tombacIcon_1.default('ShiftDates')(SvgShiftDates);
//# sourceMappingURL=ShiftDates.js.map